<template>
  <Tabs v-bind="$attrs" v-on="$listeners" class="testv__tabs">
    <TabPane
      v-for="item in options"
      :key="item.name"
      :label="item.label"
      :name="item.name">
      <template v-if="$scopedSlots.customLabel || item.icon" slot="label">
        <slot name="customLabel" :tab="item">
          <component :is="item.icon" class="testv__tabs__icon"/>
        </slot>
      </template>
      <slot :name="item.name"/>
    </TabPane>
  </Tabs>
</template>

<script>
import { Tabs, TabPane } from 'element-ui'
import 'element-ui/lib/theme-chalk/tabs.css'
import 'element-ui/lib/theme-chalk/tab-pane.css'

export default {
  name: 'TestvTabs',

  components: {
    Tabs,
    TabPane
  },

  props: {
    options: Array
  }
}
</script>

<style lang="stylus" scoped>
.testv__tabs {
  >>> .el-tabs__nav-scroll {
    text-align: center;
  }
  >>> .el-tabs__nav-wrap {
    margin-bottom: 0px;
  }
  >>> .el-tabs__nav {
    display: inline-block;
    border-radius: 36px;
    background: var(--dark-bwb-3);
    float: none;
  }
  >>> .el-tabs__active-bar {
    width: 36px!important;
    height: 36px;
    border-radius: 50px;
    background: var(--yellow-testv);
    z-index: 0;
    margin-left: -8px;
  }
  >>> .el-tabs__item {
    height: 36px;
    padding: 8px;
    display: inline-flex;
    align-items: center;
    color: var(--dark-bwb-8);
    &.is-active {
      color: var(--dark-bwb-0);
      transition-delay: 0.18s;
    }
    &:nth-child(2) {
      padding-left: 8px;
    }
    &:last-child {
      padding-right: 8px;
    }
  }
  .testv__tabs__icon {
    width: 20px;
    height: 20px;
    color: inherit;
    transition-duration: .2s;
  }
}
</style>
